import type { ReactNode } from 'react';

export const symbol_notifications_unread: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Zm0-422ZM190-200q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h50v-304q0-84 49.5-150.5T420-798v-22q0-25 17.5-42.5T480-880q22.92 0 38.96 14.5T539-830q-12 20-19 42.5t-9 46.5q-8-2-15.28-2.5-7.29-.5-15.72-.5-75 0-127.5 52.5T300-564v304h360v-284q15 3 30 4t30-1v281h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H190Zm433-452.12q-32-32.12-32-78T623.12-808q32.12-32 78-32T779-807.88q32 32.12 32 78T778.88-652q-32.12 32-78 32T623-652.12Z"
		/>
	</svg>
);
